import * as yup from "yup";
interface BookValidationSchemaProps {
  languageSpecialization: boolean;
}

const BookValidationSchema = ({
  languageSpecialization,
}: BookValidationSchemaProps) => {
  let schema = yup.object().shape({
    title: yup
      .string()
      .max(100, "Title cannot exceed 100 characters")
      .required("Title is required"),
    author: yup
      .string()
      .max(100, "Author cannot exceed 100 characters")
      .required("Author is required"),
    publisher: yup
      .string()
      .max(100, "Publisher cannot exceed 100 characters")
      .required("Publisher is required"),
    copyright: yup
      .number()
      .typeError("Provied a valid year for Copyright")
      .required("Copyright is required")
      .max(new Date().getFullYear())
      .min(1000, "Requires four digit year YYYY"),
    summary: yup
      .string()
      .max(1000, "Max character limit reached")
      .required("Description is required"),
  });

  const secondLanguageFields = {
    summary2ndLanguage: yup
      .string()
      .max(1000, "Max character limit reached")
      .required("Summary in second language is required"),
  };

  if (languageSpecialization) {
    schema = schema.shape(secondLanguageFields);
  }

  return schema;
};

export default BookValidationSchema;
